import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { ServerPicksList } from "@/components/predictions/ServerPicksList";
import { getPublicUpcomingPicks } from "@/lib/publicPicks.functions";
import { hubJsonLd } from "@/lib/picksJsonLd";

const picksQuery = queryOptions({ queryKey: ["public-upcoming-picks"], queryFn: () => getPublicUpcomingPicks(), staleTime: 5 * 60_000 });
import HighOddsPortal from "@/pages/HighOddsPortal";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/high-odds")({
  loader: ({ context }) => context.queryClient.ensureQueryData(picksQuery),
  head: ({ loaderData }) => ({
    meta: [
      { title: "High Odds Predictions Today: Big-Price Football Tips | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["highOdds"] }).meta },
      { name: "description", content: "High odds predictions today: big-price football tips and value bets, each ranked by AI confidence with odds and a plain-English reason. Bet responsibly." },
      { property: "og:title", content: "High Odds Predictions Today: Big-Price Football Tips | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "High odds predictions today: big-price football tips and value bets, each ranked by AI confidence with odds and a plain-English reason. Bet responsibly." },
      { name: "twitter:title", content: "High Odds Predictions Today: Big-Price Football Tips | Statlign" },
      { name: "twitter:description", content: "High odds predictions today: big-price football tips and value bets, each ranked by AI confidence with odds and a plain-English reason. Bet responsibly." },
    ],
    scripts: hubJsonLd({ path: "/high-odds", name: "High odds predictions", description: "High-odds football tips with value prices and full reasoning.", picks: (loaderData ?? []).filter((p) => (p.odds ?? 0) >= 3).concat((loaderData ?? []).filter((p) => (p.odds ?? 0) < 3)).slice(0, 20) }),
  }),
  component: HighOddsRoute,
});

function HighOddsRoute() {
  const { data } = useSuspenseQuery(picksQuery);
  const picks = [...data].sort((a, b) => (b.odds ?? 0) - (a.odds ?? 0)).slice(0, 20);
  return (
    <MainLayout>
      <HighOddsPortal />
      <ServerPicksList picks={picks} />
    </MainLayout>
  );
}
